import React, {Component} from 'react'
import { Paper } from '@mui/material'

class Footer extends Component {
    state = {
        bannerIndex: 0,
        bannerHref: '',
        linkHref: '',
        ads: []
    };

    componentDidMount() {
        var timer = window.setInterval(this.cycleBanner, 5000);
        this.setState({ timer: timer });
    }

    componentWillUnmount() {
        clearInterval(this.state.timer)
    }
    
    cycleBanner = () => {
        if (this.state && this.state.ads && this.state.ads.length > 0) {
            this.setState({
                bannerHref: this.state.ads[this.state.bannerIndex].imageHref,
                linkHref: this.state.ads[this.state.bannerIndex].linkHref
            })
            if (this.state.bannerIndex === this.state.ads.length - 1) {
                this.setState({
                    bannerIndex: 0
                })
            } else {
                this.setState({
                    bannerIndex: this.state.bannerIndex + 1
                })
            }
        }
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.ads !== this.props.ads && this.props.ads.length > 0) {
            this.setState({
                ads: this.props.ads
            })
        }
    }

    render() {

        return (
            <Paper style={{
                position: "fixed",
                bottom: "0",
                width: "100%",
                height: 60,
                marginLeft: 260,
                background: "#212429"
            }}>
                <img src={this.state.bannerHref} height="100%"  alt=""/>
            </Paper>
        )
    }
}

export default Footer